import React, { useCallback, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { InputSearch, Button, LinearProgress } from 'Components';
import { Grid, Typography } from '@mui/material';
import Checkbox from 'Components/Checkbox';
import { MenuComponent } from 'Components/Menu';
import { TagsGroup } from 'Components/Tag';
import InfiniteScroll from "react-infinite-scroll-component";
import FormCreateEdit from './components/createEdit';
import FormDelete from './components/delete';

import './index.scss';
import Loading from 'Components/Loading';

import {
    searchFormSettings,
    openFormCreateEdit,
    openFormDelete,
    clearRedux
} from 'Redux/actions';

const FormSettings = (props) => {
    //const
    const { messages } = useIntl();

    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchText, setSearchText] = useState("");
    //Selectors
    const {
        loadingForms,
        forms,
        filters,
        total
    } = useSelector(state => state.fsmSettingsRedux);

    useEffect(() => {
        dispatch(searchFormSettings(filters));
        return () => {
            dispatch(clearRedux("FSM_SETTINGS_FORM"));
        }
    }, []);


    const onSearch = useCallback((text) => {
        if (window.typingTime) {
            clearTimeout(window.typingTime)
        }

        setSearchText(text);
        window.typingTime = setTimeout(() => {
            dispatch(searchFormSettings({ ...filters, openSearch: text || "", offset: 0, reset: true }));
            window.typingTime = null;
        }, 500);
    });

    const callBack = useCallback(() => {
        setSelectedRows([]);
        dispatch(searchFormSettings({ ...filters, openSearch: searchText || "", offset: 0, reset: true }));
    });

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={searchText || ""}
                        onSearch={onSearch}
                    />
                </Grid>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                style={{ paddingTop: 10 }}
            >
                <Grid item xs>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        onClick={() => {
                            dispatch(openFormCreateEdit(true))
                        }}
                    />
                    <Button
                        type="icon"
                        icon="delete"
                        disabled={!selectedRows?.length}
                        tooltip={messages['delete']}
                        onClick={() => {
                            dispatch(openFormDelete(true, selectedRows))
                        }}
                    />
                </Grid>

                <Grid item xs className='text-right'>
                    {
                        forms?.length > 0 &&
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            <Grid item>
                                <Checkbox
                                    id={'fsm-form-select-all'}
                                    value={forms?.length === selectedRows.length}
                                    className='allSelection-checkbox'
                                    onChange={(checked) => {
                                        if (checked) {
                                            setSelectedRows(forms);
                                        } else {
                                            setSelectedRows([]);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    className="btn-cancel btn-sm"
                                    style={{
                                        color: '#333333'
                                    }}
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        if (selectedRows?.length === forms?.length) {
                                            setSelectedRows([]);
                                        } else {
                                            setSelectedRows(forms);
                                        }
                                        
                                    }}
                                >
                                    {messages['fsm_settings_form_selectAll']}
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>

            <div>
                {
                    loadingForms &&
                    <LinearProgress color="primary" />
                }

                <InfiniteScroll
                    dataLength={total || 0}
                    height="calc(100vh - 320px)"
                    next={() => {
                        dispatch(searchFormSettings({
                            ...filters,
                            offset: filters?.offset + filters?.limit
                        }));
                    }}
                    hasMore={forms?.length < total}
                    loader={<></>}
                    endMessage={
                        <React.Fragment>
                            {
                                !loadingForms &&
                                <div style={{ padding: 8, fontSize: 12, color: 'grey', textAlign: "center" }}>
                                    {`${total ? messages['fsm_settings_form_no_more_items'] : messages['fsm_settings_form_no_items_found']}`}
                                </div>
                            }
                        </React.Fragment>
                    }
                    style={{
                        overflow: 'hidden auto'
                    }}
                >
                    {
                        forms?.length > 0 && forms?.map((row, index) => {
                            let selected = selectedRows.find(selectedRow => selectedRow.id === row.id);

                            return (
                                <Grid
                                    key={index}
                                    item xs
                                    style={{ width: '100%', margin: 0 }}
                                >
                                    <div style={{ padding: '5px 4px 8px 3px' }}>
                                        <div className="formSettingsView-card formSettingsView-container">
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                wrap="nowrap"
                                            >
                                                <Grid item>
                                                    <Checkbox
                                                        id={`fsm-form-${row?.id}`}
                                                        value={selected ? true : false}
                                                        className='label-no-margin'
                                                        size="sm"
                                                        onChange={(checked) => {

                                                            let newSelectedRows = [];
                                                            if (checked) {
                                                                newSelectedRows = [...selectedRows];
                                                                newSelectedRows.push(row);
                                                            } else {
                                                                newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== row.id);
                                                            }

                                                            setSelectedRows([...newSelectedRows]);
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs zeroMinWidth>
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle1"
                                                        className="formSetting-title"
                                                    >
                                                        {row?.name}
                                                    </Typography >
                                                </Grid>

                                                <Grid item>
                                                    <MenuComponent
                                                        icon={'more_vert'}
                                                        options={[
                                                            messages['edit'],
                                                            messages['delete']
                                                        ]}
                                                        className="formSetting-actions showInHover"
                                                        onClick={(type) => {
                                                            if (type === messages['edit']) {
                                                                dispatch(openFormCreateEdit(true, row))
                                                            } else {
                                                                dispatch(openFormDelete(true, [row]))

                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                style={{
                                                    marginTop: 8
                                                }}
                                            >
                                                <Grid item className='text-left'>
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle2"
                                                        color={'textSecondary'}
                                                        style={{
                                                            marginRight: 10,
                                                            marginLeft: 4
                                                        }}
                                                    >
                                                        {messages['fsm_settings_form_tags']}
                                                    </Typography>
                                                </Grid>

                                                <Grid
                                                    item
                                                    style={{
                                                        paddingBottom: 8
                                                    }}
                                                >
                                                    <TagsGroup
                                                        options={row?.tags}
                                                        nameField="label"
                                                        colorField="color"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>

                            )
                        })
                    }
                </InfiniteScroll>
            </div>

            <FormCreateEdit callBack={callBack}/>
            <FormDelete callBack={callBack} />
        </div>
    );
}

export default FormSettings;